/**
 * DropActionType - Action permettant au joueur de déposer un objet
 * Identique à Flutter DropActionType
 */

import {ActionType} from '../../types/ActionType';
import {GameState} from '../../../models/GameState';
import {PlayerStep} from '../../../models/PlayerStep';
import {PlayerNotification} from '../../../models/PlayerNotification';

export class DropActionType implements ActionType {
  typeName = 'drop';

  async execute(
    gameState: GameState,
    currentStep: PlayerStep,
    params?: {[key: string]: any},
  ): Promise<PlayerNotification[]> {
    const objectId = params?.id;
    if (!objectId) {
      throw new Error('DropActionType: missing id parameter');
    }

    // Chercher l'objet dans l'inventaire
    const objectIndex = gameState.data.objects?.findIndex(
      (obj) => obj.attributeId === objectId && obj.dropped === 0,
    );

    if (objectIndex === undefined || objectIndex === -1) {
      throw new Error(`DropActionType: object with id ${objectId} not found in inventory`);
    }

    // Marquer l'objet comme lâché (dropped = numéro de l'étape actuelle)
    const currentStepNumber = gameState.data.currentStepNumber || 1;
    if (gameState.data.objects) {
      gameState.data.objects[objectIndex].dropped = currentStepNumber;
    }

    // Chercher le nom de l'objet pour la notification
    const object = currentStep.objects?.find((obj) => obj.id === objectId);
    const objectName = object?.name || objectId;

    // Créer une notification
    const notification: PlayerNotification = {
      title: `${objectName} déposé !`,
      description: `Vous avez déposé ${objectName}.`,
      isCheat: false,
    };

    console.log(`[DropActionType] Dropped object: ${objectId} (${objectName})`);
    return [notification];
  }
}
